import { render } from "./MergeCompetitorModal.vue?vue&type=template&id=7bbcc7b7"
import script from "./MergeCompetitorModal.vue?vue&type=script&lang=ts"
export * from "./MergeCompetitorModal.vue?vue&type=script&lang=ts"
script.render = render

export default script